import type { FaireProductEntity } from "../../entity_types/product";

export const p_3y9tftjgbw: FaireProductEntity = {
  token: "p_3y9tftjgbw",
  type: "product",
  name: "Radiant Initial Necklaces - Black Rhinestone",
  brandToken: "b_6t4mvvvp2x",
  brandName: "The Sis Kiss",
  imageUrl:
    "https://cdn.faire.com/fastly/0c282ac3fc4cf14f3a4f70e3153d29b407c8646742cdb255c20f17fe8cfdf4cd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6659c53c3d7148ed02600d484519d45fe5f4c30f3537811c3ae3ec1f6646dcb4.jpeg",
    "https://cdn.faire.com/fastly/4abb017898f6d73520b08b2ad60eaeda68fa06700a6a78cc3e7b65ec2219f41b.jpeg",
  ],
  priceDollars: 15.24,
  description:
    'New Black Rhinestone options for our very popular Radiant Initial Necklaces! \n\nDetails - \nMaterial: Plated  Black Rhodium\nLength: 16" + 2" extension\n',
  tags: [],
  msrpDollars: 52.66,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:43.823Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
